import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  texts: string[]
  size?: 10 | 12 | 14 | 16 | 20 | 24 | 32 | 40
  color?: TextColor
  weight?: 'normal' | 'bold'
  lineHeight?: 100 | 120 | 150
}

const PointText = ({
  texts,
  size = 14,
  color = TextColor.PRIMARY,
  weight = 'normal',
  lineHeight = 120
}: Props) => (
  <ul className='flex list-disc flex-col gap-1 pl-4'>
    {texts.map((text, i) => (
      <li key={i}>
        <Text size={size} color={color} weight={weight} lineHeight={lineHeight}>
          {text}
        </Text>
      </li>
    ))}
  </ul>
)

export default PointText
